import { Environment } from './Environment';

export const getSubdomain = () => {
    const hostname = window?.location?.hostname;
    if (!hostname) {
        return null;
    }

    const hostnamesToIgnore = [
        `localhost`,
        `${Environment.DOMAIN}`,
        `dev.${Environment.DOMAIN}`,
        `beta.${Environment.DOMAIN}`,
        `public-web.${Environment.DOMAIN}`,
        `public-web.dev.${Environment.DOMAIN}`,
        `public-web.beta.${Environment.DOMAIN}`,
    ];

    if (hostnamesToIgnore.includes(hostname)) {
        return null;
    }

    if (hostname.includes('.vercel.app') === true) {
        return null;
    }

    return hostname.split('.')[0];
};

export default getSubdomain;
